import directives from '../module';
import {HttpSvcFactory} from '../../services/HttpSvc';
import {BackendSvc} from '../../services/BackendSvc';
import {Utils} from '../../underscore-extensions';

class ProjectAccessCtrl {
    project: anm.Project;
    access = {
        PUBLIC: 'PUBLIC',
        PRIVATE: 'PRIVATE',
        UNLISTED: 'UNLISTED'
    };
    product: AnimatronProduct = Utils.getProduct();
    userFeatures: anm.Features = options.user.subscriptionDetails.studio.features;
    isAdmin: boolean = !!this.userFeatures.Admin;
    canOnlyRead: boolean = !this.project.isOwner && this.isAdmin;
    isShowAccess: boolean = this.project.isOwner;
    canChangePermissions: boolean = !options.user.anonymous && this.userFeatures.ProjectPermissions.canChangePermissions;
    canWrite: boolean = this.canChangePermissions;
    countPrivateUnlistedProjects: number;

    constructor(private $state: ng.ui.IStateService,
                private $http: ng.IHttpService,
                private HttpSvc: HttpSvcFactory,
                private BackendSvc: BackendSvc) {

        if (this.canChangePermissions) {
            this.countPrivateUnlistedProjects = this.userFeatures.PrivateUnlistedProjects.numProjects;
            this.HttpSvc(`projects/stats?product=${this.product}`).secureGet().then(r => r.data).then((res: anm.ProjectStats) => {
                const countProjectCreated = res.privateProjects + res.unlistedProjects;
                this.canWrite = countProjectCreated < this.countPrivateUnlistedProjects
                    || this.project.visibility !== this.access.PUBLIC;
            });
        }
    }

    get url() {
        return this.BackendSvc.getServerUrl(this.project)
            .then(url => `${url}/project/update/permission/${this.project.id}`);
    }

    changeVisibility(accessType: string) {
        this.project.visibility = accessType;
    }

    changeAccess(accessType: string) {
        if (this.project.visibility !== accessType) {
            const data = this.project.product === 'WAVE' && accessType === 'PUBLIC' ?
                      {
                          'visibility': accessType,
                          'writeAccess': [] as string[],
                          'readAccess': ['PUBLIC'] as string[]
                      } :
                      {
                          'visibility': accessType,
                          'writeAccess': [] as string[],
                          'readAccess': [] as string[]
                      },
                  oldVisibility = this.project.visibility;

            this.changeVisibility(accessType);
            this.url.then(url => {
                this.$http.put(url, data, {headers: options.headers})
                    .then((res: any) => {
                        if (res && res.data.code) {
                            this.changeVisibility(oldVisibility);
                            _.notification.showError(res.data.message || 'Error changing project access');
                        }
                    });
            });
        }
    }

    openSubscription() {
        this.$state.go(`${this.product.toLowerCase()}-settings.subscription`);
    }
}

directives.directive('projectAccess', () => ({
    restrict: 'E',
    controller: ProjectAccessCtrl,
    controllerAs: 'ProjectAccess',
    bindToController: {
        project: '='
    },
    scope: true,
    templateUrl: require('project/project-access.html')
}));



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/project/projectAccessDirective.ts